export const allVesselsSelector = state => state.vessel.allVessels

export const vesselsSelector = state => state.vessel.vessels

export const vesselSelector = state => state.vessel.vessel

export const requestingVesselsSelector = state => state.vessel.requestingVessels

export const requestingVesselSelector = state => state.vessel.requestingVessel

export const vesselPaginationSelector = state => state.vessel.pagination

export const vesselSearchQuerySelector = state => state.vessel.searchQuery

export const savingVesselDetailsSelector = state =>
  state.vessel.savingVesselDetails

export const saveVesselDetailsErrorSelector = state =>
  state.vessel.saveVesselDetailsError
